import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import MDButton from "components/MDButton";
import type { DREGerencialView } from "../types/dre-gerencial.types";
import FinanceiroSection from "./FinanceiroSection";
import DREGerencialResumoCards from "./DREGerencialResumoCards";
import DREGerencialTabela from "./DREGerencialTabela";
import DREQualidadeAlert from "./DREQualidadeAlert";

type Props = {
  data: DREGerencialView | null;
  loading: boolean;
  error: string | null;
  isEmpty: boolean;
  refetch: () => void;
  /** Sem `FinanceiroSection` — página dedicada com `LojaPageContainer`. */
  embedded?: boolean;
};

function DRESkeleton() {
  return (
    <Stack spacing={2}>
      <Grid container spacing={2}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Grid item xs={12} sm={6} md={i < 3 ? 4 : 6} key={`dre-card-sk-${i}`}>
            <Card
              elevation={0}
              sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}
            >
              <Box sx={{ p: 2 }}>
                <Skeleton width="40%" />
                <Skeleton width="60%" height={40} sx={{ mt: 1 }} />
                <Skeleton width="80%" sx={{ mt: 1 }} />
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Card
        elevation={0}
        sx={{ border: 1, borderColor: "divider", borderRadius: 2, p: 2 }}
      >
        <Skeleton height={28} width="30%" sx={{ mb: 2 }} />
        <Skeleton height={240} />
      </Card>
    </Stack>
  );
}

export default function DREGerencialSection({
  data,
  loading,
  error,
  isEmpty,
  refetch,
  embedded = false,
}: Props) {
  const corpo = (
    <>
      {error ? (
        <Alert
          severity="error"
          sx={{ mb: 2 }}
          action={
            <MDButton
              color="dark"
              variant="outlined"
              size="small"
              onClick={refetch}
            >
              Tentar novamente
            </MDButton>
          }
        >
          {error}
        </Alert>
      ) : null}

      {loading ? <DRESkeleton /> : null}

      {!loading && !error && isEmpty ? (
        <Alert severity="info" sx={{ mb: 0 }}>
          Nenhum dado de DRE encontrado para o período selecionado.
        </Alert>
      ) : null}

      {!loading && !error && !isEmpty && data ? (
        <Stack spacing={2}>
          <DREQualidadeAlert qualidade={data.qualidadeDados} />
          <DREGerencialResumoCards view={data} loading={false} />
          <DREGerencialTabela view={data} />
        </Stack>
      ) : null}
    </>
  );

  if (embedded) {
    return corpo;
  }

  return (
    <FinanceiroSection
      titulo="DRE Gerencial"
      subtitulo="Resultado por competência no período selecionado."
    >
      {corpo}
    </FinanceiroSection>
  );
}
